// extracted by mini-css-extract-plugin
export default {"container":"VCysAWGJ","loader":"_T59myeL","loading-text":"E59ODomF","loadingText":"E59ODomF"};